module.exports = __webpack_public_path__ + "img/03.1e72f787.jpg";